<template>
  <div>
    <div class="title" />
    <div class="metric" />
  </div>
</template>

<script>
export default {
  name: 'MetricPlaceholder'
}
</script>

<style scoped lang="scss">
$placeholder-colour: #dbdee7;

.title {
  width: 128px;
  height: 16px;
  border-radius: 16px;
  margin-bottom: 8px;
  background-color: $placeholder-colour;
}

.metric {
  width: 80px;
  height: 24px;
  border-radius: 24px;
  background-color: $placeholder-colour;
}
</style>



// WEBPACK FOOTER //
// src/common/components/MetricPlaceholder.vue